const ID = {
    CHANGE_PATIENT_STATUS: 1,
    DESEXED_PATIENT: 3,
    CREATE_REMINDER: 4,
    CREATE_TASK: 5,
    CREATE_ALERT: 6,
    PRINT_CERTIFICATE: 7,
    DISABLE_REMINDER: 8,
    CREATE_LETTER: 9,
    ADD_ATTACHMENT: 10,
    CREATE_FORM: 11
};

export default {
    ID
};
